import React, { useEffect, useRef, useState } from 'react';
import './FacilityClaim.scss';
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TablePagination,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Tooltip,
    Chip
} from "@mui/material";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import numeral from "numeral";
import ConfirmDialog from '../../../components/confirmDialog/confirmDialog';
import CircularButton, { CustomButtonSmallDarkBg, CustomLoadingButton } from '../../../components/ui/CustomButton';
import { MdAdd, MdClose, MdDelete, MdEmail, MdNumbers, MdPhone, MdSave } from 'react-icons/md';
import { IoArrowForwardSharp, IoClose, IoDocumentTextSharp } from 'react-icons/io5';
import { TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import EmailComponent from '../../../components/emailComponent/EmailComponent';
import OnScreenReports from '../../../components/onScreenReports/OnScreenReports';
import Confetti from "react-confetti";
import newRequest from '../../../utils/newRequest';
import moment from "moment";
import OtpInput from 'react-otp-input';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import ExpandableComponent from '../../../components/expandableComponent/ExpandableComponent';
import { formatNumber, formatNumberWithDigitGrouping, formatStringToNumberV2, getCssValue } from '../../../utils/genericFunctions';
import { CiImageOn, CiViewTimeline } from 'react-icons/ci';
import { showToast } from '../../../toastService';
import useConfigStore from '../../../zustand/useConfigStore';
import { qilloIconMap } from '../../../utils/iconMapping';
import { ImHome } from 'react-icons/im';
import { FiSearch } from 'react-icons/fi';
import FileUploadComponent from '../../../components/fileUploadComponent/FileUploadComponent';
import AllFiles from '../../../components/allFiles/AllFiles';
import { useTranslation } from 'react-i18next';
import { customSelectStyles_dark, customSelectStyles_light } from '../../../components/ui/CustomSelect';
import TraceData from '../../../components/traceData/TraceData';
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import Contributions from '../../../components/contributions/Contributions.jsx';
import { IoIosRefresh } from 'react-icons/io';
import GaugePointer from '../../../components/gaugePointer/GaugePointer.jsx';


const FacilityClaim = () => {
    const socket = useSelector((state) => state.socket.socket);
    const { t } = useTranslation();
    const { entityPlansData } = useConfigStore();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const navigate = useNavigate();
    const location = useLocation();
    const parts = location.pathname.split("/");
    const [passedDocId, setPassedDocId] = useState(parts[parts.length - 1]);
    const [claimData, setClaimData] = useState(null);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [saveEnabled, setSaveEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Validate");
    const [isConfettiActive, setIsConfettiActive] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);

    const symptomRef = useRef(null);
    const diagnosisRef = useRef(null);

    // trace data
    const [traceKey, setTraceKey] = useState(0);
    const handleRefreshTraceData = () => {
        setTraceKey(prevKey => prevKey + 1);
    };

    // email component 
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [otp, setOtp] = useState("");
    // claim fields

    const [fraudCheckResult, setFraudCheckResult] = useState(null);

    const [cmNo, setCmNo] = useState(null);
    const [cmRemarks, setCmRemarks] = useState(null);
    const [cmFacilityEntCode, setCmFacilityEntCode] = useState(null);
    const [cmFacilityRefNo, setCmFacilityRefNo] = useState(null);
    const [cmPriorityLevel, setCmPriorityLevel] = useState(null);
    const [cmSubmissionDate, setCmSubmissionDate] = useState(null);
    const [cmResponseDate, setCmResponseDate] = useState(null);

    const [cmSymptoms, setCmSymptoms] = useState([]);
    const [cmDiagnosis, setCmDiagnosis] = useState([]);

    const [cmVisitDate, setCmVisitDate] = useState(null);
    const [cmStatus, setCmStatus] = useState(null);
    const [cmSearchParams, setCmSearchParams] = useState(null);
    const [cmClaimServices, setCmClaimServices] = useState([]);
    const [cmMemberEntCode, setCmMemberEntCode] = useState(null);
    const [selectedProcedure, setSelectedProcedure] = useState(null);

    const [totalRequested, setTotalRequested] = useState(0);
    const [totalApproved, setTotalApproved] = useState(0);
    const [attachmentsData, setAttachmentsData] = useState([]);

    const [symptoms, setSymptoms] = useState([]);
    const [selectedSymptom, setSelectedSymptom] = useState(null);
    const [diagnosis, setDiagnosis] = useState([]);
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);

    // plan fields
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [planCode, setPlanCode] = useState(null);
    const [planCodeName, setPlanName] = useState(null);
    const [planEnabled, setPlanEnabled] = useState(null);
    const [categories, setCategories] = useState([]);

    // category fields
    const [isCategoryDialogOpened, setIsCategoryDialogOpened] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [searchPlanCategory, setSearchPlanCategory] = useState("");
    const [serviceCategory, setServiceCategory] = useState(null);
    const [serviceCategoryName, setServiceCategoryName] = useState(null);
    const [serviceCategoryIcon, setServiceCategoryIcon] = useState(null);
    const [selectedIcon, setSelectedIcon] = useState(null);
    // services
    const [searchTermServices, setSearchTermServices] = useState("");
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState(null);

    const [rowsPerPageServices, setRowsPerPageServices] = useState(8);
    const [currentPageServices, setCurrentPageServices] = useState(0);

    const [priorities, setPriorities] = useState([]);

    const handlePageChangeService = (event, newPage) => {
        setCurrentPageServices(newPage);
    };

    const handleRowsPerPageServices = (event) => {
        setRowsPerPageServices(parseInt(event.target.value, 8));
        setCurrentPageServices(0);
    };

    const handleSetClaimData = (name, value) => {
        setClaimData((prev) => {
            return { ...prev, [name]: value };
        });
    };


    const handleSelectedSymptom = async (selectedOption) => {
        try {
            if (selectedOption && selectedOption.__isNew__) {
                const res = await newRequest.post(
                    "/sysCode/add",
                    {
                        sys_type: "Symptoms",
                        sys_code: selectedOption?.value,
                        sys_name: selectedOption?.value
                    }
                );

                setSelectedSymptom({
                    value: selectedOption?.value,
                    label: selectedOption?.value,
                });

                showToast(`${selectedOption.value} added to the list!`, "success");
            } else {
                setSelectedSymptom(selectedOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSelectedDiagnosis = async (selectedOption) => {
        try {
            if (selectedOption && selectedOption.__isNew__) {
                const res = await newRequest.post(
                    "/sysCode/add",
                    {
                        sys_type: "Diagnosis",
                        sys_code: selectedOption?.value,
                        sys_name: selectedOption?.value
                    }
                );

                setSelectedDiagnosis({
                    value: selectedOption?.value,
                    label: selectedOption?.value,
                });

                showToast(`${selectedOption.value} added to the list!`, "success");
            } else {
                setSelectedDiagnosis(selectedOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Function to handle OTP change
    const handleOtpChange = (newOtp) => {
        setOtp(newOtp);
        // Start validation when OTP reaches 6 digits
        if (newOtp.length === 6) {
            validateOtp(newOtp);
        }
    };

    // Function to validate OTP
    const validateOtp = async (enteredOtp) => {
        // console.log("Validating OTP:", enteredOtp);
        try {
            setIsProcessing(true);
            const res = await newRequest.post("/meds/validateOtp", {
                claim_docid: passedDocId,
                entered_otp: enteredOtp
            });
            // console.log(`validateOtp ${JSON.stringify(res.data, null, 2)}`);
            if (res.data.msg === "success") {
                await fetchClaim(passedDocId, false);
                navigate(`/cfm/${passedDocId}`, { replace: true });
                showToast("OTP validated successfully.", "success");

                // setClaimData(res.data.doc);
                // setCmStatus(res.data.doc.cm_status);
                // setDocumentEnabled(res.data?.doc?.document_enabled_xx);
                // setNextAction(res.data?.doc?.next_action_xx);
                // setSaveEnabled(res.data?.doc?.save_enabled_xx);
            } else if (res.data.msg === "error") {
                setNotifyDialogTitle("Error");
                setNotifyDialogText("Invalid OTP entered. Please try again.");
                setIsNotifyDialogOpen(true);
            }
            handleRefreshTraceData();
            setIsProcessing(false);
        } catch (error) {
            console.log(error);
        }
    };

    const handleConfirm = async () => {
        try {
            // console.log(`1 cmClaimServices ${JSON.stringify(cmClaimServices, null, 2)}`);
            const formattedServices = cmClaimServices.map(service => ({
                ...service,
                service_approved: 0,
                service_amount: formatStringToNumberV2(service.service_amount, 2)
            }));
            setCmClaimServices(formattedServices);
            // console.log(`1 formattedServices ${JSON.stringify(formattedServices, null, 2)}`);
            if (confirmDialogAction === "submitClaim") {
                setIsProcessing(true);

                const res = await newRequest.put(`/meds/upd/${passedDocId}`, {
                    cm_status: "Awaiting Approval",
                    cm_symptoms: cmSymptoms,
                    cm_diagnosis: cmDiagnosis,
                });
                if (res.data?.msg === "updated") {
                    // set new claim data and statuses to enable and disable other functions
                    await fetchClaim(passedDocId, true);
                    navigate(`/cfm/${passedDocId}`, { replace: true });
                    setIsProcessing(false);
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText("Claim successfully submitted for approval. You will be notified when there's a change in the claim status!");
                    setIsNotifyDialogOpen(true);
                } else {
                    setNotifyDialogTitle("Error!");
                    setNotifyDialogText("There was an error submitting the claim!");
                    setIsNotifyDialogOpen(true);
                }
                handleRefreshTraceData();
            } else if (confirmDialogAction === "sendReply") {
                setIsProcessing(true);
                const res = await newRequest.put(`/meds/upd/${passedDocId}`, {
                    cm_status: "Response Received",
                    cm_symptoms: cmSymptoms,
                    cm_diagnosis: cmDiagnosis,
                });
                if (res.data?.msg === "updated") {
                    // set new claim data and statuses to enable and disable other functions
                    await fetchClaim(passedDocId, true);
                    navigate(`/cfm/${passedDocId}`, { replace: true });
                    setIsProcessing(false);
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(`Response successfully sent to ${claimData?.facility_details_xx?.ent_name}!`);
                    setIsNotifyDialogOpen(true);
                } else {
                    setNotifyDialogTitle("Error!");
                    setNotifyDialogText("There was an error sending response!");
                    setIsNotifyDialogOpen(true);
                }
                handleRefreshTraceData();
            } else if (confirmDialogAction === "moveToPayment") {
                setIsProcessing(true);
                const res = await newRequest.put(`/meds/upd/${passedDocId}`, {
                    cm_status: "Awaiting Payment",
                    cm_symptoms: cmSymptoms,
                    cm_diagnosis: cmDiagnosis,
                });
                if (res.data?.msg === "updated") {
                    // set new claim data and statuses to enable and disable other functions
                    await fetchClaim(passedDocId, true);
                    navigate(`/cfm/${passedDocId}`, { replace: true });
                    setIsProcessing(false);
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(`Claim moved payment queue!`);
                    setIsNotifyDialogOpen(true);
                } else {
                    setNotifyDialogTitle("Error!");
                    setNotifyDialogText("There was an error sending response!");
                    setIsNotifyDialogOpen(true);
                }
                handleRefreshTraceData();
            } else if (confirmDialogAction === "closeClaim") {
            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };

    const fetchPriorities = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findAll", { sys_type: "Priority Level" }
            );
            const options = res.data?.map((rn) => ({
                value: rn?.sys_code,
                label: rn?.sys_code,
            }));
            setPriorities(options);
        } catch (err) {
            console.log(err);
        }
    };


    const saveRecord = async (e) => {
        // e.preventDefault();
        try {
            // if (!entType?.value) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select type!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }
            // console.log(`claimData ${JSON.stringify(claimData, null, 2)}`);
            // console.log(`cmClaimServices ${JSON.stringify(cmClaimServices, null, 2)}`);
            const formattedServices = cmClaimServices.map(service => ({
                ...service,
                service_approved: formatStringToNumberV2(service.service_approved, 2),
                service_amount: formatStringToNumberV2(service.service_amount, 2)
            }));

            const res = await newRequest.put(`/meds/upd/${passedDocId}`,
                {
                    ...claimData,
                    cm_symptoms: cmSymptoms,
                    cm_diagnosis: cmDiagnosis,
                    cm_claim_services: formattedServices
                }
            );
            // await fetchEntityTrace(entCode);
            setNotifyDialogTitle("Success!");
            setNotifyDialogText(`Successfully saved!`);
            setIsNotifyDialogOpen(true);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchClaim = async (doc_id, firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            }
            const res = await newRequest.get(`/meds/find/${doc_id}`);

            if (res.data) {
                //  set claims information
                setClaimData(res.data);
                setCmNo(res.data.cm_no);
                setCmRemarks(res.data.cm_remarks);
                setCmFacilityEntCode(res.data.cm_facility_ent_code);
                setCmFacilityRefNo(res.data.cm_facility_ref_no);
                setCmVisitDate(res.data.cm_visit_date);
                setCmStatus(res.data.cm_status);
                setCmSearchParams(res.data.cm_search_params);

                // Format service_approved and service_amount for display
                const formattedServices = res.data.claim_services_xx.map(service => ({
                    ...service,
                    service_approved: formatNumber(service?.service_approved || 0),
                    service_amount: formatNumber(service?.service_amount || 0)
                }));
                setCmClaimServices(formattedServices);
                // setCmClaimServices(res.data.claim_services_xx);

                setCmMemberEntCode(res.data.cm_member_ent_code);
                setDocumentEnabled(res.data.document_enabled_xx);
                setNextAction(res.data.next_action_xx);
                setSaveEnabled(res.data.save_enabled_xx);

                setCmPriorityLevel({
                    value: res.data.cm_priority_level,
                    label: res.data.cm_priority_level
                });

                setCmSubmissionDate(res.data.cm_submission_date);
                setCmResponseDate(res.data.cm_response_date);

                setCmSymptoms(res.data.cm_symptoms);
                setCmDiagnosis(res.data.cm_diagnosis);
            }

            // fetch attachments
            fetchDocumentAttachments("allclaim", res.data._id);
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };

    const handleServiceInputChange = (e, id, field) => {
        try {
            const newSmiData = [...cmClaimServices];
            const index = newSmiData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                newSmiData[index][field] = e.target.value;
                setCmClaimServices(newSmiData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleServiceBlur = (id, field) => {
        try {
            const updatedData = [...cmClaimServices];
            const index = updatedData.findIndex(smi => smi._id === id);

            if (index !== -1) {
                let value = updatedData[index][field];
                const numberFields = ["service_approved", "service_amount", "service_qty"];

                let serviceAmount = parseFloat(formatStringToNumberV2(updatedData[index]["service_amount"] || 0));

                // console.log(`field is ${field}`);
                // console.log(`value is ${value}`);
                // console.log(`serviceAmount is ${serviceAmount} and formatted is ${formatStringToNumberV2(value)}`);

                // If the approved amount is greater than the service amount, reset to zero
                if (field === "service_approved" && parseFloat(formatStringToNumberV2(value)) > serviceAmount) {
                    updatedData[index]["service_approved"] = 0;

                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(
                        `You cannot approve an amount greater than the applied amount of ${numeral(serviceAmount).format("0,0.00")}. Resetting approval to zero!`
                    );
                    setIsNotifyDialogOpen(true);
                } else {
                    if (numberFields.includes(field)) {
                        updatedData[index][field] = formatStringToNumberV2(value);
                    } else {
                        updatedData[index][field] = value;
                    }
                }

                setCmClaimServices(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const fetchDocumentAttachments = async (docType, docid) => {
        try {
            const res = await newRequest.post(
                "/files/findDocFiles",
                {
                    fl_org_code: currentUser.usr_org_code,
                    fl_doc_type: docType,
                    fl_parent_doc_id: docid,
                },
            );

            setAttachmentsData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSymptoms = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Symptoms" });
            const options = res.data.map((mode) => ({
                value: mode?.sys_code,
                label: mode?.sys_name,
            }));
            setSymptoms(options);
        } catch (error) {
            console.error("Error fetching symptoms", error);
        }
    };
    const runFraudCheckResult = async () => {
        try {
            const res = await newRequest.get(`/meds/fraudCheck/${passedDocId}`);
            setFraudCheckResult(res.data);
        } catch (error) {
            console.error("Error fetching symptoms", error);
        }
    };


    const fetchDiagnosis = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Diagnosis" });
            const options = res.data.map((mode) => ({
                value: mode?.sys_code,
                label: mode?.sys_name,
            }));
            setDiagnosis(options);
        } catch (error) {
            console.error("Error fetching diagnosis", error);
        }
    };

    const filteredServices = services?.filter(
        (row) =>
            row?.service_title?.toLowerCase().includes(searchTermServices.toLowerCase()) ||
            row?.service_ref?.toLowerCase().includes(searchTermServices.toLowerCase()) ||
            row?.service_desc?.toLowerCase().includes(searchTermServices.toLowerCase())
    );

    const paginatedServices = filteredServices?.slice(
        currentPageServices * rowsPerPageServices,
        currentPageServices * rowsPerPageServices + rowsPerPageServices
    );


    useEffect(() => {
        const requestedAmount = cmClaimServices.reduce(
            (sum, mi) => sum + (formatStringToNumberV2(mi.service_amount) || 0), 0
        );
        const approvedAmount = cmClaimServices.reduce(
            (sum, mi) => sum + (formatStringToNumberV2(mi.service_approved) || 0), 0
        );
        setTotalRequested(requestedAmount);
        setTotalApproved(approvedAmount);
    }, [cmClaimServices]);


    useEffect(() => {
        setServices([]);
        setServices(selectedCategory?.services);
    }, [selectedCategory]);

    useEffect(() => {
        if (passedDocId === "new" || passedDocId === undefined) {
            setDocumentEnabled("Y");
        } else {
            fetchClaim(passedDocId, true);
        }

        // set selected default plan and show its services
        if (entityPlansData) {
            setSelectedPlan(entityPlansData[0]);
            setPlanCode(entityPlansData[0]?.plan_code);
            setPlanName(entityPlansData[0]?.plan_name);
            setPlanEnabled(entityPlansData[0]?.plan_enabled);
            setCategories(entityPlansData[0]?.categories);
            setSelectedCategory(entityPlansData[0]?.categories[0]);
            setCurrentPageServices(0);
        }

        // set priorities
        fetchPriorities();
        fetchSymptoms();
        fetchDiagnosis();

        // run fraud check 
        if (!currentUser?.usr_entity_code) {
            runFraudCheckResult();
        }

        // Listen for updated claim events
        socket.on("updatedClaim", async (claim) => {
            if (claim?._id === passedDocId && claim?.cm_status === "Response Received") {
                showToast(`This claim has been updated`, "success");
                setIsProcessing(true);
                await fetchClaim(passedDocId, false);
                navigate(`/cfm/${passedDocId}`, { replace: true });
                handleRefreshTraceData();
                setIsProcessing(false);
            }
        });

        return () => {
            socket.off("updatedClaim");
        };

    }, [passedDocId]);

    return (
        <motion.div
            className="facility-claim"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="facility-claim-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <h1 className="main-title">
                                {claimData?.client_details_xx?.ent_name || "NEW CLAIM"}
                            </h1>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="left"
                                endIcon={<IoIosRefresh />}
                                onClick={async () => {
                                    try {
                                        await fetchClaim(passedDocId);
                                        handleRefreshTraceData();
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            {nextAction !== "None" &&
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoArrowForwardSharp />}
                                    onClick={() => {
                                        try {
                                            let prompt = "";
                                            switch (cmStatus) {
                                                case "Validated":
                                                    setConfirmationActiontext(`Do you want to submit this claim for approval?`);
                                                    // setCurrentAction("submitClaim");
                                                    setConfirmDialogAction("submitClaim");
                                                    break;
                                                case "Response Received":
                                                    if (totalApproved === 0) {
                                                        setConfirmationActiontext(`Do you want to close this claim?`);
                                                    } else {
                                                        prompt = t("moveToPayment", { claimNo: cmNo });
                                                        setConfirmationActiontext(prompt);
                                                    }
                                                    // setCurrentAction("closeClaim");
                                                    setConfirmDialogAction(totalApproved === 0 ? "closeClaim" : "moveToPayment");
                                                    break;
                                                case "Awaiting Approval":
                                                    setConfirmationActiontext(`Do you want to send reply to ${claimData?.facility_details_xx?.ent_name}?`);
                                                    setConfirmDialogAction("sendReply");
                                                    break;
                                                default:
                                                    setConfirmDialogAction(null);
                                            }

                                            if (cmClaimServices?.length === 0 && cmStatus === "Validated") {
                                                setNotifyDialogTitle("Note!");
                                                setNotifyDialogText("You have not selected any services!");
                                                setIsNotifyDialogOpen(true);
                                                return;
                                            }

                                            setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                >
                                    {nextAction}
                                </CustomLoadingButton>}
                            {saveEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {passedDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="content-wrapper">
                            <div className="claim-content-details">
                                <div className="claim-no-view">
                                    <span className="sub-title">{`${t('claimNo').toUpperCase()} : ${cmNo}`}</span>
                                    <span className={`status ${getCssValue(cmStatus)}`}>{`${t('status').toUpperCase()} : ${cmStatus}`}</span>
                                    <span className="sub-title">{`${t('date').toUpperCase()} : ${moment(cmVisitDate).format("Do MMMM YYYY HH:mm")}`}</span>
                                </div>
                                {cmStatus === "Awaiting OTP"
                                    && <div className='otp-view'>
                                        <p>Enter OTP</p>
                                        <OtpInput
                                            value={otp}
                                            onChange={handleOtpChange}
                                            numInputs={6}
                                            renderSeparator={<span>-</span>}
                                            renderInput={(props) => <input {...props} />}
                                            inputStyle={{
                                                width: "40px",
                                                height: "40px",
                                                fontSize: "20px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                textAlign: "center",
                                            }}
                                        />
                                        <CustomButtonSmallDarkBg
                                            width={"200px"}
                                            currentTheme={currentTheme}
                                            onClick={async () => {
                                                try {
                                                    setIsProcessing(true);
                                                    const res = await newRequest.post("/meds/resendOtp", { claim_docid: passedDocId });
                                                    if (res.data.msg === "resent") {
                                                        handleRefreshTraceData();
                                                        showToast("OTP successfully resent.", "success");
                                                    }
                                                    setIsProcessing(false);
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                            // startIcon={<MdSend />}
                                            isCurrent={true}
                                        >
                                            {t('resend')}
                                        </CustomButtonSmallDarkBg>
                                    </div>}
                                {!currentUser?.usr_entity_code &&
                                    <motion.div
                                        className="client-details-container"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <div className="single-client company">
                                            <div className="single-client-left">
                                                {claimData?.facility_details_xx?.ent_photo_url ?
                                                    <img src={claimData?.facility_details_xx?.ent_photo_url} alt="" /> : <CiImageOn style={{ width: "80px", height: "80px" }} />}
                                            </div>
                                            <div className="single-client-right">
                                                <div className="single-client-header">
                                                    <span className='client-name'>{claimData?.facility_details_xx?.ent_name}</span>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                                        <span className="relationship-type">{`PIN: ${claimData?.facility_details_xx?.ent_tax_no}`}</span>
                                                        <h3 className={`status ${claimData?.facility_details_xx?.ent_status}`}>{`Status ${claimData?.facility_details_xx?.ent_status}`}</h3>
                                                    </div>
                                                </div>
                                                <div className="client-phone-row">
                                                    <span className="client-phone-details f3" >
                                                        <MdEmail className="icon" /> <span>{claimData?.facility_details_xx?.ent_email || "Unspecified"}</span>
                                                    </span>
                                                    <span className="client-phone-details f2">
                                                        <MdPhone className="icon" /> <span>{claimData?.facility_details_xx?.ent_phone_no}</span>
                                                    </span>
                                                    <span className="client-phone-details f2">
                                                        <CiViewTimeline className="icon" /> <span>{claimData?.facility_details_xx?.ent_facility_level}</span>
                                                    </span>
                                                    <span className="client-phone-details f2">
                                                        <MdNumbers className="icon" /> <span>{claimData?.facility_details_xx?.ent_code}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>}
                                <ExpandableComponent
                                    title={t('additionalInformation')}
                                    subtitle={documentEnabled === "N" &&
                                        <span className={`status ${cmPriorityLevel?.value}`}> <h1 className='main-title'>{`Your Ref : ${cmFacilityRefNo || "Unspecified"} - Priority ${cmPriorityLevel?.label}`}</h1> </span>
                                    }
                                    bgColor="#fff"
                                    defaultExpanded={true}
                                >
                                    <div className="patient-wrapper">
                                        {documentEnabled === "Y" &&
                                            <div className="claim-additional-details">
                                                <div className="input-item-with-label">
                                                    <label htmlFor="cm_facility_ref_no"
                                                        className="form-dropdown-label"
                                                        style={{ width: "90px" }}>
                                                        {t('yourRef')}
                                                    </label>
                                                    <input
                                                        name="cm_facility_ref_no"
                                                        type="text"
                                                        placeholder="REF No"
                                                        className="form-input-item"
                                                        style={{ width: "300px" }}
                                                        value={cmFacilityRefNo}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetClaimData("cm_facility_ref_no", e.target.value);
                                                                setCmFacilityRefNo(e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label
                                                        htmlFor="cm_priority_level"
                                                        className="form-dropdown-label"
                                                        style={{ width: "100px" }}>
                                                        {t('priority')}
                                                    </label>
                                                    <Select
                                                        id="cm_priority_level"
                                                        name="cm_priority_level"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                            })
                                                        }}
                                                        width="300px"
                                                        value={cmPriorityLevel}
                                                        onChange={(selectedOption) => {
                                                            try {
                                                                handleSetClaimData(
                                                                    "cm_priority_level",
                                                                    selectedOption.value
                                                                );
                                                                setCmPriorityLevel(selectedOption);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        options={priorities}
                                                        isSearchable={true}
                                                        placeholder="Priority"
                                                        isDisabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                            </div>}
                                        {documentEnabled === "Y" &&
                                            <div className="claim-additional-details">
                                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                                    <label htmlFor="cm_remarks"
                                                        className="form-dropdown-label"
                                                        style={{ width: "100px", alignSelf: "flex-start" }}>
                                                        {t('remarks')}
                                                    </label>
                                                    <textarea
                                                        name="cm_remarks"
                                                        type="text"
                                                        row={3}
                                                        placeholder="Remarks"
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={cmRemarks}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetClaimData("cm_remarks", e.target.value);
                                                                setCmRemarks(e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                            </div>}
                                        {documentEnabled === "N" && <p style={{ margin: "0px 10px 5px 10px" }}>{`${t('remarks').toUpperCase()}: ${cmRemarks}`}</p>}
                                        {/* <hr className='separator-h' /> */}
                                        {/* <h1 className='main-title'>{t('patient').toUpperCase()}</h1> */}
                                        <motion.div
                                            className="client-details-container"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1, transition: { duration: 1 } }}
                                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                                            <div className="single-client">
                                                <div className="single-client-left">
                                                    {claimData?.client_details_xx?.ent_photo_url ?
                                                        <img src={claimData?.client_details_xx?.ent_photo_url} alt="" /> : <CiImageOn style={{ width: "80px", height: "80px" }} />}
                                                </div>
                                                <div className="single-client-right">
                                                    <div className="single-client-header">
                                                        <span className='client-name'>{claimData?.client_details_xx?.ent_name}</span>
                                                        <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                                            <span className="relationship-type">{claimData?.client_details_xx?.ent_age_xx}</span>
                                                            <h3 className={`status ${claimData?.client_details_xx?.ent_status}`}>{`Status ${claimData?.client_details_xx?.ent_status}`}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="client-phone-row">
                                                        <span className="client-phone-details f3" >
                                                            <MdEmail className="icon" /> <span>{claimData?.client_details_xx?.ent_email || "Not Specified"}</span>
                                                        </span>
                                                        <span className="client-phone-details f2">
                                                            <MdPhone className="icon" /> <span>{claimData?.client_details_xx?.ent_phone_no}</span>
                                                        </span>
                                                        <span className="client-phone-details f2">
                                                            {!["Male", "Female"].includes(claimData?.client_details_xx?.ent_gender) && <span className="client-phone-details"><TbGenderEpicene className="icon" /> {claimData?.client_details_xx?.ent_gender}</span>}
                                                            {["Male"].includes(claimData?.client_details_xx?.ent_gender) && <span className="client-phone-details"><PiGenderMaleBold className="icon" /> {claimData?.client_details_xx?.ent_gender}</span>}
                                                            {["Female"].includes(claimData?.client_details_xx?.ent_gender) && <span className="client-phone-details"><PiGenderFemaleBold className="icon" /> {claimData?.client_details_xx?.ent_gender}</span>}
                                                        </span>
                                                        <span className="client-phone-details f2"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => { }}>
                                                            <MdNumbers className="icon" /> <span>{claimData?.client_details_xx?.ent_code}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                </ExpandableComponent>
                                {/* CONTRIBUTIONS */}
                                {!currentUser?.usr_entity_code &&
                                    <Contributions entCode={claimData?.client_details_xx?.ent_code} showStatement='Y' entityId={claimData?.client_details_xx?._id} />}
                                <ExpandableComponent
                                    title={t('selectedServices')}
                                    subtitle={
                                        <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                            <span className='status InProgress'><h1 className="sub-title">{`${t('requested').toUpperCase()} ${numeral(totalRequested).format("0,0.00")}`}</h1></span>
                                            <hr className='separator-v' />
                                            <span className='status Approved'><h1 className="sub-title">{`${t('approved').toUpperCase()} ${numeral(totalApproved).format("0,0.00")}`}</h1></span>
                                        </div>
                                    }
                                    bgColor="#fff"
                                    defaultExpanded={true}
                                >
                                    <div className="selected-wrapper">
                                        {/* <h1 className='sub-title'>TOTAL SELECTED</h1> */}
                                        {cmClaimServices?.length > 0 &&
                                            <div className="table-content">
                                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                                        <TableHead className="tablehead">
                                                            <TableRow className="tablerow">
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    #
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", width: "100%" }}>
                                                                        <span>{t('service').toUpperCase()}</span>
                                                                        {cmClaimServices?.length > rowsPerPageServices &&
                                                                            <div className="search-input-wrapper" style={{ width: "60%" }}>
                                                                                <FiSearch className="search-input-icon" />
                                                                                <input
                                                                                    className="search-input"
                                                                                    type="text"
                                                                                    placeholder="Search service..."
                                                                                    value={searchTermServices}
                                                                                    onChange={(e) => {
                                                                                        try {
                                                                                            setSearchTermServices(e.target.value);
                                                                                            if (e.target.value) {
                                                                                                setCurrentPageServices(0);
                                                                                            }
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                {searchTermServices.length > 0 && (
                                                                                    <IoClose
                                                                                        onClick={async (e) => {
                                                                                            try {
                                                                                                setSearchTermServices("");
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }}
                                                                                        className="search-input-icon"
                                                                                    />
                                                                                )}
                                                                                {searchTermServices.length === 0 && (
                                                                                    <span className="search-input-icon" />
                                                                                )}
                                                                            </div>}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                                                    <span>{t('qty').toUpperCase()}</span>
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                    <span>{`LIMIT ${currentUser?.currency_code_xx}`}</span>
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                    <span>{t('applied').toUpperCase()}</span>
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                    <span>{t('approved').toUpperCase()}</span>
                                                                </TableCell>
                                                                {documentEnabled === "Y" ?
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                        <span>{t('action').toUpperCase()}</span>
                                                                    </TableCell> :
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "10px" }} />}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody className="tablebody">
                                                            {cmClaimServices?.map((row, index) => (
                                                                <TableRow
                                                                    key={row?._id}
                                                                    className={`${selectedProcedure?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                    onClick={() => {
                                                                        try {
                                                                            setSelectedProcedure(row);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                >
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                        {index + 1}
                                                                    </TableCell>
                                                                    <TableCell className="table-cell" style={{ width: "auto" }}>
                                                                        <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "column" }}>
                                                                            <h1 className="sub-title">{row.service_desc}</h1>
                                                                            {/* <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "row" }}>
                                                                                <h1 className="sub-title soft xrsmall">{`REF : ${row.service_ref}`}</h1>
                                                                                {row.service_complexity !== "Normal" && <h1 className="sub-title soft xrsmall">{`Complexity :${row.service_complexity}`}</h1>}
                                                                                {row.service_speciality !== "General" && <h1 className="sub-title soft xrsmall">{`Speciality :${row.service_speciality}`}</h1>}
                                                                            </div> */}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                                                        <h1 className="sub-title">{numeral(row.service_qty).format("0,0")}</h1>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                        <h1 className="sub-title">{numeral(row.service_limit).format("0,0.00")}</h1>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                        {cmStatus === "Validated" ?
                                                                            <div className="input-item-with-label">
                                                                                <input
                                                                                    id="service_amount"
                                                                                    name="service_amount"
                                                                                    value={row.service_amount}
                                                                                    onChange={(e) => handleServiceInputChange(e, row._id, 'service_amount')}
                                                                                    // onChange={(e) => handleServiceApprovedChange(e, row._id, "service_amount")}
                                                                                    onBlur={() => handleServiceBlur(row._id, "service_amount")}
                                                                                    // onBlur={() => validateApprovedAmount(row._id, "service_amount")}
                                                                                    style={{ width: "100%", textAlign: "right" }}
                                                                                    className="form-input-item table"
                                                                                />
                                                                            </div> :
                                                                            <h1 className="sub-title">{numeral(row.service_amount).format("0,0.00")}</h1>}
                                                                    </TableCell>
                                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                        {currentUser?.usr_entity_code
                                                                            ? // If usr_entity_code is not null, always show the h1
                                                                            <h1 className="sub-title">{numeral(row.service_approved).format("0,0.00")}</h1>
                                                                            : // If usr_entity_code is null and status is "Awaiting Approval", show input
                                                                            cmStatus === "Awaiting Approval" ? (
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id="service_approved"
                                                                                        name="service_approved"
                                                                                        value={row.service_approved}
                                                                                        onChange={(e) => handleServiceInputChange(e, row._id, 'service_approved')}
                                                                                        // onChange={(e) => handleServiceApprovedChange(e, row._id, "service_approved")}
                                                                                        // onBlur={() => validateApprovedAmount(row._id, "service_approved")}
                                                                                        onBlur={() => handleServiceBlur(row._id, "service_approved")}
                                                                                        style={{ width: "100%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                // Default case: Show h1
                                                                                <h1 className="sub-title">{numeral(row.service_approved).format("0,0.00")}</h1>
                                                                            )}
                                                                    </TableCell>
                                                                    {documentEnabled === "Y" ?
                                                                        <TableCell className="table-cell" style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: 'space-around', padding: "3px", maxWidth: "100px", }}>
                                                                            <CircularButton
                                                                                currentTheme={currentTheme}
                                                                                onClick={(e) => {
                                                                                    try {
                                                                                        e.stopPropagation();
                                                                                        setSelectedService(row);
                                                                                        setCurrentAction("removeProcedure");
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                                        </TableCell>
                                                                        :
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "10px" }} />
                                                                    }
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>}
                                    </div>
                                    <hr className='separator-h' />
                                    <h1 className='main-title'>{t('notes')}</h1>
                                    <AllDocsNote
                                        key={traceKey}
                                        docId={passedDocId}
                                        docType="SClaim"
                                        noteType={"Normal"}
                                    />
                                </ExpandableComponent>
                                {documentEnabled === "Y" &&
                                    <ExpandableComponent
                                        title={t('availableServices')}
                                        subtitle={selectedPlan?.plan_name}
                                        bgColor="#fff"
                                        defaultExpanded={cmStatus === "Validated"}
                                    >
                                        <div className="available-wrapper">
                                            {entityPlansData?.length > 1 &&
                                                <div className="available-top">
                                                    <div className="options-list">
                                                        {entityPlansData?.map((plan) => (
                                                            <>
                                                                <span
                                                                    key={plan?._id}
                                                                    className={`${selectedPlan?._id === plan?._id
                                                                        ? "single-option active"
                                                                        : "single-option"
                                                                        }`}
                                                                    onClick={async () => {
                                                                        try {
                                                                            setSelectedPlan(plan);
                                                                            setPlanCode(plan?.plan_code);
                                                                            setPlanName(plan?.plan_name);
                                                                            setPlanEnabled(plan?.plan_enabled);
                                                                            setCategories(plan?.categories);
                                                                            setSelectedCategory(plan?.categories[0]);
                                                                            setCurrentPageServices(0);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                >
                                                                    <span className="cy-title">{plan?.plan_name}</span>
                                                                    <span className="cy-type">{plan?.plan_code}</span>
                                                                </span>
                                                                {/* <hr className="separator-h" /> */}
                                                            </>
                                                        ))}
                                                    </div>
                                                </div>}
                                            <div className="available-bottom">
                                                {categories?.length > 1 &&
                                                    <div className="categories-wrapper">
                                                        {categories?.map((catg) => {
                                                            const IconComponent = qilloIconMap[catg?.sys_flex01] || ImHome;
                                                            return (
                                                                <div key={catg?.service_category}
                                                                    className={`${selectedCategory?.service_category === catg?.service_category ? "sub-menu-item current" : "sub-menu-item"}`}
                                                                    onClick={async () => {
                                                                        try {
                                                                            setSelectedCategory(catg);
                                                                            setCurrentPageServices(0);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}>
                                                                    <IconComponent className="sub-menu-icon" />
                                                                    <div className="sub-menu-content">
                                                                        <div className="sub-menu-name">{catg?.service_category_name}</div>
                                                                        <div className="sub-menu-description">{catg?.service_category}</div>
                                                                    </div>
                                                                </div>)
                                                        })}
                                                    </div>}
                                            </div>
                                            <hr className='separator-h' />
                                            <div className="available-services">
                                                <div className="table-content">
                                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                                            <TableHead className="tablehead">
                                                                <TableRow className="tablerow">
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                        #
                                                                    </TableCell>
                                                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", width: "100%" }}>
                                                                            <span>{t('service').toUpperCase()}</span>
                                                                            {services?.length > rowsPerPageServices &&
                                                                                <div className="search-input-wrapper" style={{ width: "60%" }}>
                                                                                    <FiSearch className="search-input-icon" />
                                                                                    <input
                                                                                        className="search-input"
                                                                                        type="text"
                                                                                        placeholder={`${t('search')} ${t('service')}`}
                                                                                        value={searchTermServices}
                                                                                        onChange={(e) => {
                                                                                            try {
                                                                                                setSearchTermServices(e.target.value);
                                                                                                if (e.target.value) {
                                                                                                    setCurrentPageServices(0);
                                                                                                }
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    {searchTermServices.length > 0 && (
                                                                                        <IoClose
                                                                                            onClick={async (e) => {
                                                                                                try {
                                                                                                    setSearchTermServices("");
                                                                                                } catch (error) {
                                                                                                    console.log(error);
                                                                                                }
                                                                                            }}
                                                                                            className="search-input-icon"
                                                                                        />
                                                                                    )}
                                                                                    {searchTermServices.length === 0 && (
                                                                                        <span className="search-input-icon" />
                                                                                    )}
                                                                                </div>}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                        <span>{`${t('limit')} ${currentUser?.currency_code_xx}`}</span>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                        <span>{t('action').toUpperCase()}</span>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody className="tablebody">
                                                                {paginatedServices?.map((row, index) => (
                                                                    <TableRow
                                                                        key={row?._id}
                                                                        className={`${selectedService?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                setSelectedService(row);
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell" style={{ width: "auto" }}>
                                                                            <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "column" }}>
                                                                                <h1 className="sub-title">{row.service_title}</h1>
                                                                                <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "row" }}>
                                                                                    <h1 className="sub-title soft xrsmall">{`REF : ${row.service_ref}`}</h1>
                                                                                    {row.service_complexity !== "Normal" && <h1 className="sub-title soft xrsmall">{`Complexity :${row.service_complexity}`}</h1>}
                                                                                    {row.service_speciality !== "General" && <h1 className="sub-title soft xrsmall">{`Speciality :${row.service_speciality}`}</h1>}
                                                                                </div>
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                            <h1 className="sub-title">{numeral(row.service_limit).format("0,0.00")}</h1>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell" style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: 'space-around', padding: "3px", maxWidth: "100px", }}>
                                                                            <CircularButton
                                                                                currentTheme={currentTheme}
                                                                                onClick={async (e) => {
                                                                                    try {
                                                                                        e.stopPropagation();
                                                                                        setSelectedService(row);
                                                                                        setCurrentAction("addService");
                                                                                        // console.log(`selectedPlan ${JSON.stringify(selectedPlan, null, 2)}`);
                                                                                        // console.log(`selectedCategory ${JSON.stringify(selectedCategory, null, 2)}`);
                                                                                        // console.log(`setSelectedService ${JSON.stringify(row, null, 2)}`);
                                                                                        const res = await newRequest.post("/meds/addProcedure",
                                                                                            {
                                                                                                claim_docid: passedDocId,
                                                                                                service_plan_code: selectedPlan?.plan_code,
                                                                                                service_title: row?.service_title,
                                                                                                service_category: selectedCategory?.service_category,
                                                                                                service_ref: row?.service_ref,
                                                                                                service_desc: row?.service_desc,
                                                                                                service_limit: row?.service_limit,
                                                                                                service_qty: 1,
                                                                                                service_amount: row?.service_limit,
                                                                                                service_approved: 0,
                                                                                                service_icon: row?.service_icon,
                                                                                                service_complexity: row?.service_complexity,
                                                                                                service_speciality: row?.service_speciality,
                                                                                                service_specialist_ent_code: "",
                                                                                            });

                                                                                        if (res.data?.msg === "added") {
                                                                                            setCmClaimServices((prevParams) => [...prevParams, res.data?.doc]);
                                                                                            handleRefreshTraceData();
                                                                                            showToast("Added!", "success");
                                                                                        } else if (res.data?.msg === "exists") {
                                                                                            showToast(`${row?.service_desc} is already added to this claim`, "warning");
                                                                                        } else {
                                                                                            showToast("Error adding report!", "error");
                                                                                        }
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }} icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        {services?.length > rowsPerPageServices &&
                                                            <TablePagination
                                                                rowsPerPageOptions={[8]}
                                                                rowsPerPage={rowsPerPageServices}
                                                                onRowsPerPageChange={handleRowsPerPageServices}
                                                                component="div"
                                                                count={services?.length}
                                                                rows={services}
                                                                page={currentPageServices}
                                                                onPageChange={handlePageChangeService}
                                                            />}
                                                    </TableContainer>
                                                </div>
                                            </div>
                                        </div>
                                    </ExpandableComponent>}
                                <ExpandableComponent
                                    title={t('symptomsDiagnosis').toUpperCase()}
                                    subtitle={""}
                                    bgColor="#fff"
                                    defaultExpanded={true}
                                >
                                    <div className="symptoms-diagnosis-wrapper">
                                        <div className="symptoms-wrapper">
                                            {documentEnabled === "Y" ?
                                                <div className="symptoms-toolbar">
                                                    <div className="input-item-with-label" style={{ display: "flex", width: "100%", gap: "5px" }}>
                                                        {/* <label
                                                        htmlFor="symptoms"
                                                        className="form-dropdown-label"
                                                        style={{ width: "100px" }}
                                                    >
                                                        SYMPTOMS
                                                    </label> */}
                                                        <CreatableSelect
                                                            ref={symptomRef}
                                                            id="symptoms"
                                                            name="symptoms"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="100%"
                                                            value={selectedSymptom}
                                                            onChange={handleSelectedSymptom}
                                                            options={symptoms}
                                                            isSearchable={true}
                                                            placeholder="Symptoms"
                                                        />
                                                        <CustomLoadingButton
                                                            currentTheme={currentTheme}
                                                            iconPosition="end"
                                                            borderRadiusType="right"
                                                            endIcon={<MdAdd />}
                                                            onClick={async (e) => {
                                                                try {
                                                                    setIsProcessing(true);
                                                                    const res = await newRequest.post("/meds/addSymptomDiagnosis",
                                                                        {
                                                                            claim_docid: passedDocId,
                                                                            attribute_type: "cm_symptoms",
                                                                            attribute_value: selectedSymptom?.value
                                                                        });
                                                                    setIsProcessing(false);
                                                                    if (res.data?.msg === "added") {
                                                                        // setCmSymptoms((prevParams) => [...prevParams, res.data?.doc]);
                                                                        setCmSymptoms((prevParams) => {
                                                                            // Use Set to prevent duplicates
                                                                            const updatedSet = new Set([...prevParams, res.data?.doc]);
                                                                            return Array.from(updatedSet); // Convert back to array
                                                                        });

                                                                        setSelectedSymptom(null);
                                                                        handleRefreshTraceData();
                                                                        showToast("Added!", "success");

                                                                        // Refocus on selection list
                                                                        setTimeout(() => symptomRef.current?.focus(), 100);

                                                                    } else if (res.data?.msg === "exists") {
                                                                        setSelectedSymptom(null);
                                                                        showToast(`${selectedSymptom?.value} is already added`, "warning");

                                                                        // Refocus on selection list
                                                                        setTimeout(() => symptomRef.current?.focus(), 100);

                                                                    } else {
                                                                        showToast("Error adding report!", "error");
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                        >
                                                            {t('add')}
                                                        </CustomLoadingButton>
                                                    </div>
                                                </div>
                                                :
                                                <h1 className='main-title'>{t('symptoms').toUpperCase()}</h1>
                                            }
                                            <div className="symptoms-content">
                                                <div className="chip-wrapper">
                                                    {cmSymptoms?.map((sym, index) => (
                                                        <Tooltip
                                                            key={index}
                                                            title={sym}
                                                            placement="left"
                                                        >
                                                            <Chip
                                                                label={sym}
                                                                className="chip"
                                                                onDelete={documentEnabled === "Y" ? async (e) => {
                                                                    try {
                                                                        setIsProcessing(true);
                                                                        const res = await newRequest.post("/meds/deleteSymptomDiagnosis", {
                                                                            claim_docid: passedDocId,
                                                                            attribute_type: "cm_symptoms",
                                                                            attribute_value: sym
                                                                        });
                                                                        setIsProcessing(false);
                                                                        if (res.data?.msg === "removed") {
                                                                            setCmSymptoms((prev) => prev.filter(report => report !== sym));
                                                                            handleRefreshTraceData();
                                                                            showToast("Removed!", "success");
                                                                        } else {
                                                                            showToast("Error removing!", "error");
                                                                        }
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                } : undefined}
                                                            />
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="diagnosis-wrapper">
                                            {documentEnabled === "Y" ?
                                                <div className="diagnosis-toolbar">
                                                    <div className="input-item-with-label" style={{ display: "flex", width: "100%", gap: "5px" }}>
                                                        {/* <label
                                                        htmlFor="diagnosis"
                                                        className="form-dropdown-label"
                                                        style={{ width: "100px" }}
                                                    >
                                                        DIAGNOSIS
                                                    </label> */}
                                                        <CreatableSelect
                                                            ref={diagnosisRef}
                                                            id="diagnosis"
                                                            name="diagnosis"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="100%"
                                                            value={selectedDiagnosis}
                                                            onChange={handleSelectedDiagnosis}
                                                            options={diagnosis}
                                                            isSearchable={true}
                                                            placeholder="Diagnosis"
                                                        />
                                                        <CustomLoadingButton
                                                            currentTheme={currentTheme}
                                                            iconPosition="end"
                                                            borderRadiusType="right"
                                                            endIcon={<MdAdd />}
                                                            onClick={async (e) => {
                                                                try {
                                                                    setIsProcessing(true);
                                                                    const res = await newRequest.post("/meds/addSymptomDiagnosis",
                                                                        {
                                                                            claim_docid: passedDocId,
                                                                            attribute_type: "cm_diagnosis",
                                                                            attribute_value: selectedDiagnosis?.value
                                                                        });
                                                                    setIsProcessing(false);

                                                                    if (res.data?.msg === "added") {
                                                                        setCmDiagnosis((prevParams) => {
                                                                            // Use Set to prevent duplicates
                                                                            const updatedSet = new Set([...prevParams, res.data?.doc]);
                                                                            return Array.from(updatedSet); // Convert back to array
                                                                        });

                                                                        setSelectedDiagnosis(null);
                                                                        handleRefreshTraceData();
                                                                        showToast("Added!", "success");

                                                                        // Refocus on selection list
                                                                        setTimeout(() => diagnosisRef.current?.focus(), 100);

                                                                    } else if (res.data?.msg === "exists") {
                                                                        setSelectedDiagnosis(null);
                                                                        showToast(`${selectedDiagnosis?.value} is already added`, "warning");

                                                                        // Refocus on selection list
                                                                        setTimeout(() => diagnosisRef.current?.focus(), 100);
                                                                    } else {
                                                                        showToast("Error adding report!", "error");
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                        >
                                                            Add
                                                        </CustomLoadingButton>
                                                    </div>
                                                </div>
                                                :
                                                <h1 className='main-title'>{t('diagnosis').toUpperCase()}</h1>
                                            }
                                            <div className="diagnosis-content">
                                                <div className="chip-wrapper">
                                                    {cmDiagnosis?.map((diag, index) => (
                                                        <Tooltip
                                                            key={index}
                                                            title={diag}
                                                            placement="left"
                                                        >
                                                            <Chip
                                                                label={diag}
                                                                className="chip"
                                                                onDelete={documentEnabled === "Y" ? async (e) => { // Only show if condition is true
                                                                    try {
                                                                        setIsProcessing(true);
                                                                        const res = await newRequest.post("/meds/deleteSymptomDiagnosis",
                                                                            {
                                                                                claim_docid: passedDocId,
                                                                                attribute_type: "cm_diagnosis",
                                                                                attribute_value: diag
                                                                            });
                                                                        setIsProcessing(false);
                                                                        if (res.data?.msg === "removed") {
                                                                            setCmDiagnosis((prev) =>
                                                                                prev.filter(report => report !== diag)
                                                                            );
                                                                            handleRefreshTraceData();
                                                                            showToast("Removed!", "success");
                                                                        } else {
                                                                            showToast("Error removing!", "error");
                                                                        }
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                } : undefined}
                                                            />
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ExpandableComponent>
                                {/* ATTACHMENTS */}
                                <ExpandableComponent
                                    title={t('attachments')}
                                    subtitle={<span className='sub-title'>{attachmentsData?.length === 1 ? `1 ${t('attachment').toUpperCase()}` : `${attachmentsData?.length} ${t('attachments').toUpperCase()}`}</span>}
                                    bgColor="#fff"
                                    defaultExpanded={false}
                                >
                                    <FileUploadComponent documentNo={cmNo} documentId={passedDocId} documentType="allclaim" fetchDocumentAttachments={fetchDocumentAttachments} uploadFolder="allclaim" />
                                    <AllFiles filesList={attachmentsData}
                                        allowPreview={claimData?.files_manipulation_xx?.find((item) => item.key === "allowPreview")?.value}
                                        allowDownload={claimData?.files_manipulation_xx?.find((item) => item.key === "allowDownload")?.value}
                                        allowDelete={claimData?.files_manipulation_xx?.find((item) => item.key === "allowDelete")?.value || "N"}
                                        allowEdit={claimData?.files_manipulation_xx?.find((item) => item.key === "allowEdit")?.value || "N"} />
                                </ExpandableComponent>
                            </div>
                        </div>
                        <div tabIndex="-1" className="summary-wrapper">
                            <div className="summary-content">
                                <div className="response-row">
                                    <span className="status Validated" style={{ width: "100%", textAlign: "right" }}><h1 className="normal-title">{`${t('requested').toUpperCase()} ${numeral(totalRequested).format("0,0.00")}`}</h1></span>
                                </div>
                                <div className="response-row">
                                    <span className="status Approved" style={{ width: "100%", textAlign: "right" }}><h1 className="normal-title">{`${t('approved').toUpperCase()} ${numeral(totalApproved).format("0,0.00")}`}</h1></span>
                                </div>
                                <div className="response-row">
                                    <span className="status Appointment" style={{ width: "100%", textAlign: "right" }}><h1 className="normal-title">{`${t('paid').toUpperCase()} ${numeral(claimData?.paid_amount_fc_xx).format("0,0.00")}`}</h1></span>
                                </div>
                                {/* Show Outstanding if NOT fully paid */}
                                {totalApproved > claimData?.paid_amount_fc_xx &&
                                    <div className="response-row">
                                        <span className="status Terminated" style={{ width: "100%", textAlign: "right" }}><h1 className="normal-title">{`${t('outstanding').toUpperCase()} ${numeral(totalApproved - parseFloat(claimData?.paid_amount_fc_xx)).format("0,0.00")}`}</h1></span>
                                    </div>}
                                {!currentUser?.usr_entity_code && <hr className='separator-h' />}
                                {!currentUser?.usr_entity_code &&
                                    <div className="failures-content">
                                        <GaugePointer value={fraudCheckResult?.fraudProbability || 0} currentTheme={currentTheme} />
                                        {fraudCheckResult?.failures?.map((row, index) => (
                                            <span key={index} className='failures-row'
                                            >
                                                <h3 className='sub-title'>{index + 1}.</h3>
                                                <h3 className='sub-title'>{row?.passText}</h3>
                                            </span>
                                        ))}
                                    </div>
                                }
                                <hr className='separator-h' />
                                <span className='main-title'>{t('timeline').toUpperCase()}</span>
                                <TraceData key={traceKey} documentId={passedDocId} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {/* email component */}
            {emailDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('email').toUpperCase()}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
                        </div>
                    </div>
                </motion.div>
            )}
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={claimData?.report_keys_array}
                                documentData={{
                                    docNo: "",
                                    docType: "Claim",
                                    docId: passedDocId,
                                    clientEmail: claimData?.client_email_xx,
                                    clientEntCode: "",
                                    clientEntName: ""
                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
            {isConfettiActive && <Confetti />}
        </motion.div >
    )
};
export default FacilityClaim;